import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import s from './StorageBadges.module.css';
export function StorageBadges({ items }) {
    if (!items.length)
        return null;
    return (_jsx("div", { className: s.chips, children: items.map((st) => {
            const label = st.name ?? st.id.slice(0, 8);
            const failed = st.status === 'failed';
            return (_jsxs("span", { title: label, className: `${s.chip} ${failed ? s.chipFailed : ''}`, children: [label, failed ? ' ✕' : ''] }, st.id));
        }) }));
}
